// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import {
  ApiResponse,
  CreateFeatureRequest,
  FeatureRecord,
  UpdateFeatureRequest,
} from './types/types';
import { handleResponse } from '../../utils/api';

// Define a service using a base URL and expected endpoints
export const featuresAPI = createApi({
  reducerPath: 'featuresAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getFeatures: builder.query<FeatureRecord[], void>({
      query: () => ({
        url: `/auth/features`,
        method: 'GET',
      }),
      transformResponse: (response: ApiResponse<FeatureRecord[]>) => response.body,
    }),
    // Mutations
    createFeature: builder.mutation({
      query: (request: CreateFeatureRequest) => ({
        url: '/auth/feature/create',
        method: 'POST',
        data: request,
      }),
      transformResponse: (response: ApiResponse<FeatureRecord>) => handleResponse(response).body,
    }),
    updateFeature: builder.mutation({
      query: (request: UpdateFeatureRequest) => ({
        url: '/auth/feature/update',
        method: 'POST',
        data: request,
      }),
      transformResponse: (response: ApiResponse<FeatureRecord>) => handleResponse(response).body,
    }),
    deleteFeature: builder.mutation({
      query: (id: number) => ({
        url: `/auth/feature/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFeaturesQuery,
  useDeleteFeatureMutation,
  useCreateFeatureMutation,
  useUpdateFeatureMutation,
} = featuresAPI;
